<router-outlet></router-outlet>
<p-toast [showTransitionOptions]="'250ms'" position="bottom-right" [showTransformOptions]="'translateX(100%)'" [hideTransitionOptions]="'150ms'" [hideTransformOptions]="'translateX(100%)'" />
<ng-progress ngProgressHttp />
<ngx-spinner
  [zIndex]="999"
  bdColor = "rgba(255, 255, 255, 0.9)"
  size = "large"
  color = "#000"
  type = "fire"
  [fullScreen]="true"
>
  <div class="app-loading">
    <div id="preloader">
      <div id="ctn-preloader" class="ctn-preloader">
        <div class="animation-preloader">
          <div class="spinner"></div>
          <div class="txt-loading">
            <span data-text-preloader="V" class="letters-loading">V</span>
            <span data-text-preloader="G" class="letters-loading">G</span>
            <span data-text-preloader="E" class="letters-loading">E</span>
          </div>
          <p class="text-center"> {{ 'Chargement'|transloco }} </p>
        </div>
      </div>
    </div>
  </div>
</ngx-spinner>
